export default "__VITE_ASSET__318b3b74__"